import React from 'react';
import { Phone } from 'lucide-react';
const PHONE = '586-203-3701';
export function StickyMobileCTA() {
  return <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-slate-200 shadow-[0_-4px_12px_-2px_rgba(0,0,0,0.1)] flex gap-2 p-3" data-id="element-239">
      <a href={`tel:${PHONE.replace(/-/g, '')}`} className="flex-1 inline-flex items-center justify-center gap-2 bg-[#1a2332] text-white font-bold py-3 rounded-full" data-id="element-240">
        <Phone className="w-4 h-4 text-[#2DB8E0]" data-id="element-241" /> Call Now
      </a>
      <a href="#quote-form" className="flex-1 inline-flex items-center justify-center bg-[#2DB8E0] text-white font-bold py-3 rounded-full" data-id="element-242">
        Get $500 Off
      </a>
    </div>;
}